const INITIAL_STATE = {
  current: [],
  future: [],
  callenge: {},
  currentOrNextChallenge: {
    handleDetails: ()=> {},
    statusModify: '',
    loading: false,
    returnClient: '',
    challenge: {},
    text: '',
  }
}

export const Creators = {
  resetChallenges: () => ({
    type: 'RESET'
  })
};

export default function challengesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_CHALLENGES':
      return {
        ...state,
        current: action.current,
        future: action.future
      }
    case 'SET_CHALLENGE_MODAL':
      return {
        ...state,
        callenge: action.callenge
      }
    case 'SET_CURRENT_OR_NEXT_CHALLENGE':
      return {
        ...state,
        currentOrNextChallenge: action.currentOrNextChallenge
      }
    default:
      return state;
  }
}
